import { render, staticRenderFns } from "./CourierCommentWindow.vue?vue&type=template&id=2feb5eab&scoped=true&"
import script from "./CourierCommentWindow.vue?vue&type=script&lang=js&"
export * from "./CourierCommentWindow.vue?vue&type=script&lang=js&"
import style0 from "./CourierCommentWindow.vue?vue&type=style&index=0&id=2feb5eab&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2feb5eab",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VAlert,VBtn,VCol,VRow,VTextarea})
